// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__32cLk","list":"BalanceDue_list__1i2Ng","listRow":"BalanceDue_listRow__1laUQ","total":"BalanceDue_total__3kiLG"};